import { render, staticRenderFns } from "./MailVoucherList.vue?vue&type=template&id=7506c66c"
import script from "./MailVoucherList.vue?vue&type=script&lang=js"
export * from "./MailVoucherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports